import { AuthContext } from '@core/shared';
import { TabGroup } from '@core/ui';
import { getRouteApi, useNavigate } from '@online-webinar/router';
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ApiKeys } from '../ApiKeys';
import { ChangePasswordForm } from '../ChangePasswordForm';
import { DeleteAccountSection } from '../DeleteAccountSection';
import { EditProfileForm } from '../EditProfileForm';
import { EmailPreferencesSection } from '../EmailPreferencesSection';
import { ManagedAccount } from '../ManagedAccount';

const route = getRouteApi('/account/$tab');
export const AccountManagementTabs = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { tab } = route.useParams();
    const [activeTab, setActiveTab] = useState(0);
    const tabs = ['profile', 'password', 'manage', 'api-keys'];
    const hasRights = useContext(AuthContext).hasRights;

    const changeTab = (tabIndex: number) => {
        navigate({ to: '/account/$tab', params: { tab: tabs[tabIndex] } });
    };

    useEffect(() => {
        const tabIndex = tabs.indexOf(tab || '');
        if (tabIndex === -1) {
            navigate({ to: '/account/$tab', params: { tab: tabs[0] } });
            return;
        }
        setActiveTab(tabIndex);
    }, [tab]);

    return (
        <TabGroup direction={TabGroup.direction.HORIZONTAL}>
            <TabGroup.TabList numTabs={2} activeTab={activeTab} setActiveTab={changeTab}>
                <TabGroup.Tab activeTab={activeTab} setActiveTab={changeTab} index={0} className="nav-tab" activeClassName="nav-tab--active">
                    <span data-testid="Profile" onClick={() => changeTab(0)}>
                        {t('Account.Tab.Profile')}
                    </span>
                </TabGroup.Tab>
                <TabGroup.Tab activeTab={activeTab} setActiveTab={changeTab} index={1} className="nav-tab" activeClassName="nav-tab--active">
                    <span data-testid="Profile" onClick={() => changeTab(1)}>
                        {t('Account.Tab.Password')}
                    </span>
                </TabGroup.Tab>
                {hasRights && (
                    <TabGroup.Tab activeTab={activeTab} setActiveTab={changeTab} index={2} className="nav-tab" activeClassName="nav-tab--active">
                        <span data-testid="Profile" onClick={() => changeTab(2)}>
                            {t('Account.Tab.ManageAccount')}
                        </span>
                    </TabGroup.Tab>
                )}
                <TabGroup.Tab activeTab={activeTab} setActiveTab={changeTab} index={3} className="nav-tab" activeClassName="nav-tab--active">
                    <span onClick={() => changeTab(3)}>
                        {t('Account.Tab.ApiKeys')}
                    </span>
                </TabGroup.Tab>
            </TabGroup.TabList>
            <TabGroup.TabPanel
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                index={0}
                className="bg-white rounded-b-lg transition-all transform"
                activeClassName="opacity-100 duration-500 translate-x-0"
                inactiveClassName="absolute left-0 right-0 top-12 opacity-0 -translate-x-2 h-0 overflow-hidden"
            >
                <EditProfileForm />
                <EmailPreferencesSection />
                <DeleteAccountSection />
            </TabGroup.TabPanel>
            <TabGroup.TabPanel
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                index={1}
                className="bg-white rounded-b-lg transition-all transform"
                activeClassName="opacity-100 duration-500 translate-x-0"
                inactiveClassName="absolute left-0 right-0 top-12 opacity-0 -translate-x-2 h-0 overflow-hidden"
            >
                <ChangePasswordForm />
            </TabGroup.TabPanel>
            {hasRights && (
                <TabGroup.TabPanel
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                    index={2}
                    className="bg-white rounded-b-lg transition-all transform"
                    activeClassName="opacity-100 duration-500 translate-x-0"
                    inactiveClassName="absolute left-0 right-0 top-12 opacity-0 -translate-x-2 h-0 overflow-hidden"
                >
                    <ManagedAccount />
                </TabGroup.TabPanel>
            )}
            <TabGroup.TabPanel
                activeTab={activeTab}
                setActiveTab={setActiveTab}
                index={3}
                className="bg-white rounded-b-lg transition-all transform"
                activeClassName="opacity-100 duration-500 translate-x-0"
                inactiveClassName="absolute left-0 right-0 top-12 opacity-0 -translate-x-2 h-0 overflow-hidden"
            >
                <ApiKeys />
            </TabGroup.TabPanel>
        </TabGroup>
    );
};
